import React from "react";
import Message from "@prism/message";
import PropTypes from "prop-types";

const SuccessMessage = ({ message, index = 0 }) => {
  
  const getMessageConfig = (type) => {
    const configs = {
      damage: {
        text: "Damage Added",
        id: "damage-success-message"
      },
      announcement: {
        text: "Announcement Added", 
        id: "announcement-success-message"
      }
    };
    return configs[type] || configs.damage;
  };

  if (!message) {
    return null;
  }

  const config = getMessageConfig(message.type);
  
  return (
    <Message
      id={config.id + index}
      isOpen={true}
      className={"floating-message"}
      style={{ '--message-index': index }}
      type="success">
      {config.text}
    </Message>
  );
};

SuccessMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.oneOf(['damage', 'announcement']).isRequired
  }),
  index: PropTypes.number
};

export default SuccessMessage;
